import PropTypes from 'prop-types';

import { addVariants } from '@agilemd/ui-utils';

import styles from './styles.module.scss';

function Tooltips({ html, offsets = {}, position = {} }) {
  const arrow = position.arrow || 'top-left';

  const offsetLeft = offsets.left || 0;
  const offsetTop = offsets.top || 0;

  const style = {};
  style.left = `${position.left - offsetLeft}px`;
  style.top = `${position.top - offsetTop}px`;

  return (
    <div className={styles['surpas-tooltips__tooltip']} style={style}>
      <span className={addVariants('surpas-tooltips__tooltip__nib', styles, arrow)} />
      <div
        className={styles['surpas-tooltips__tooltip__body']}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}

Tooltips.propTypes = {
  html: PropTypes.string.isRequired,
  offsets: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),
  position: PropTypes.shape({
    arrow: PropTypes.string,
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  })
};
export default Tooltips;
